<template>
	<div class="loader" :style="{ textAlign: center ? 'center' : false }">
		<div class="lds-ellipsis" :class="!addShadow ? 'lds-ellipsis--noshadow' : ''"><div></div><div></div><div></div><div></div></div>
	</div>
</template>
<script>
	export default {
		name: 'Loader',
		components: {},
		props: {
			addShadow: {
				type: Boolean,
				default: false,
			},
			center: {
				type: Boolean,
				default: true,
			}
		},
		data: function() {
			return {}
		}
	}
</script>
<style lang="scss">
@import 'global/css/contexte.apps.colors';
	.lds-ellipsis {
		display: inline-block;
		position: relative;
		width: 80px;
		height: 37px;
		background: white;
		border-radius: 5px;
		box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
		&--noshadow {
			box-shadow: none;
		}
	}
	.lds-ellipsis div {
		position: absolute;
		top: 13px;
		width: 11px;
		height: 13px;
		border-radius: 50%;
		background: $another-grey;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);
	}
	.lds-ellipsis div:nth-child(1) {
		left: 8px;
		animation: lds-ellipsis1 0.6s infinite;
	}
	.lds-ellipsis div:nth-child(2) {
		left: 8px;
		animation: lds-ellipsis2 0.6s infinite;
	}
	.lds-ellipsis div:nth-child(3) {
		left: 32px;
		animation: lds-ellipsis2 0.6s infinite;
	}
	.lds-ellipsis div:nth-child(4) {
		left: 56px;
		animation: lds-ellipsis3 0.6s infinite;
	}
	@keyframes lds-ellipsis1 {
		0% {
		transform: scale(0);
		}
		100% {
		transform: scale(1);
		}
	}
	@keyframes lds-ellipsis3 {
	0% {
		transform: scale(1);
	}
		100% {
		transform: scale(0);
		}
	}
	@keyframes lds-ellipsis2 {
		0% {
		transform: translate(0, 0);
		}
		100% {
		transform: translate(24px, 0);
		}
	}
</style>